import React from 'react';
import logo1 from "../assets/monomeros.webp"
import logo2 from "../assets/lasalle.webp"
import logo3 from "../assets/lasalleinst.webp"
import logo4 from "../assets/coop.webp"
import logo5 from "../assets/cooomo.webp"
import logo6 from "../assets/uninorte.webp"
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { TbHeartFilled } from 'react-icons/tb';
import { useNavigate } from "react-router-dom"

const Entidades = () => {
  const logos = [logo1, logo2, logo3, logo4, logo5, logo6];
  let navigate = useNavigate();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      
      <div className='bg-gray-50 min-h-screen'>
        {/* Encabezado con Estilo */}
        <div className='pt-20 pb-12 px-4'>
          <div className='max-w-4xl mx-auto text-center'>
            <div className='flex justify-center mb-4'>
              <TbHeartFilled className='text-red-500 animate-pulse' size={32} />
            </div>
            <h1 className="text-4xl md:text-6xl font-black text-slate-900 tracking-tight uppercase">
              Agradecimientos
            </h1>
            <div className='w-24 h-1.5 bg-blue-600 mx-auto mt-6 rounded-full'></div>
            <p className='mt-8 text-slate-500 text-lg md:text-xl font-light max-w-2xl mx-auto'>
              Agradecemos profundamente a las entidades que, con su apoyo y confianza, fortalecen nuestra labor en pro de los docentes.
            </p>
          </div>
        </div>

        {/* Rejilla de Logotipos */}
        <main className='max-w-6xl mx-auto px-6 pb-24'>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10'>
            {logos.map((logo, index) => (
              <div 
                key={index}
                className='group bg-white p-10 h-64 flex items-center justify-center rounded-[2rem] border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-500 cursor-pointer overflow-hidden relative'
              >
                {/* Fondo decorativo sutil al hacer hover */}
                <div className='absolute inset-0 bg-blue-50/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500'></div>
                
                <img 
                  className='relative z-10 w-full max-w-[180px] h-auto object-contain filter grayscale group-hover:grayscale-0 transition-all duration-700' 
                  src={logo} 
                  alt={`Entidad ${index + 1}`} 
                />
              </div>
            ))}
          </div>

          {/* Mensaje Final */}
          <div className='mt-20 p-10 bg-blue-900 rounded-[2.5rem] text-center text-white overflow-hidden relative'>
            <div className='relative z-10'>
              <h2 className='text-2xl md:text-3xl font-bold mb-4'>¿Deseas vincularte como entidad aliada?</h2>
              <p className='text-blue-200 text-lg font-light mb-8 max-w-2xl mx-auto'>
                Tu apoyo puede transformar la vida de cientos de docentes y sus comunidades. Únete a nuestra red de impacto social.
              </p>
              <button onClick={() => { navigate("/Contacto") }} className='bg-blue-600 hover:bg-white hover:text-blue-900 text-white font-bold py-4 px-10 rounded-2xl transition-all duration-300 shadow-lg'>
                Contáctanos ahora
              </button>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Entidades;